export default "/images/vendor/flag-icon-css/flags/1x1/fj.svg?b56527824f32441654654f0c0b1dc71c";